import AppLayout from '../layouts/AppLayout'

const arme_tipo1 = 1
const arme_id1 = 1

const arme_tipo3 = 3
const arme_id3 = 55

export const grabar = {
         path: '/grabar',
         name: 'grabar',
         component: AppLayout,
         meta: {
           requiresAuth: true
         },
         children: [
           {
             path: ':arme_tipo?/:arme_id?',
             name: 'grabar.index',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.index" */ '@/views/new-menu/grabar/Index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar'
                 }
               ]
             }
           },
           {
             path: 'reportes/luminarias/:arme_tipo?/:arme_id?',
             name: 'grabar.luminaria',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.luminaria" */ '@/views/proceso/menu1reporte/menu1-1luminaria/menu1-1-1list/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Luminarias'
                 }
               ]
             }
           },
           {
             path: 'reportes/luminarias/crear/:tireuc_id?',
             name: 'grabar.luminaria.create',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.luminaria.create" */ '@/views/proceso/menu1reporte/menu1-1luminaria/menu1-1-2create/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Luminarias',
                   to: { name: 'grabar.luminaria' },
                   active: true
                 },
                 {
                   text: 'Crear'
                 }
               ]
             }
           },
           {
             path: 'reportes/luminarias/editar/:arme_tipo?/:arme_id?/:id?',
             name: 'grabar.luminaria.edit',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.luminaria.edit" */ '@/views/proceso/menu1reporte/menu1-1luminaria/menu1-1-3edit/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Luminarias',
                   to: { name: 'grabar.luminaria' },
                   active: true
                 },
                 {
                   text: 'Editar'
                 }
               ]
             }
           },
           {
             path:
               'reportes/luminarias/editar/elemento/:arme_tipo?/:arme_id?/:id?',
             name: 'grabar.luminaria.elemento',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.luminaria.elemento" */ '@/views/proceso/menu1reporte/menu1-1luminaria/menu1-1-4elemento/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Luminarias',
                   to: { name: 'grabar.luminaria' },
                   active: true
                 },
                 {
                   text: 'Elemento'
                 }
               ]
             }
           },
           {
             path: 'reportes/control/:arme_tipo?/:arme_id?',
             name: 'grabar.control',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.control" */ '@/views/proceso/menu1reporte/menu1-2control/menu1-2-1list/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Control'
                 }
               ]
             }
           },
           {
             path: 'reportes/control/crear/:tireuc_id?',
             name: 'grabar.control.create',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.control.create" */ '@/views/proceso/menu1reporte/menu1-2control/menu1-2-2create/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Control',
                   to: { name: 'grabar.control' },
                   active: true
                 },
                 {
                   text: 'Crear'
                 }
               ]
             }
           },
           {
             path: 'reportes/control/editar/:arme_tipo?/:arme_id?/:id?',
             name: 'grabar.control.edit',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.control.edit" */ '@/views/proceso/menu1reporte/menu1-2control/menu1-2-3edit/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Control',
                   to: { name: 'grabar.control' },
                   active: true
                 },
                 {
                   text: 'Editar'
                 }
               ]
             }
           },
           {
             path: 'reportes/transformador/:arme_tipo?/:arme_id?',
             name: 'grabar.transformador',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.transformador" */ '@/views/proceso/menu1reporte/menu1-6transformador/menu1-6-1list/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Transformador'
                 }
               ]
             }
           },
           {
             path: 'reportes/transformador/crear/:tireuc_id?',
             name: 'grabar.transformador.create',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.transformador.create" */ '@/views/proceso/menu1reporte/menu1-6transformador/menu1-6-2create/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Transformador',
                   to: { name: 'grabar.transformador' },
                   active: true
                 },
                 {
                   text: 'Crear'
                 }
               ]
             }
           },
           {
             path: 'reportes/transformador/editar/:arme_tipo?/:arme_id?/:id?',
             name: 'grabar.transformador.edit',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.transformador.edit" */ '@/views/proceso/menu1reporte/menu1-6transformador/menu1-6-3edit/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Transformador',
                   to: { name: 'grabar.transformador' },
                   active: true
                 },
                 {
                   text: 'Editar'
                 }
               ]
             }
           },
           {
             path: 'reportes/obra/:arme_tipo?/:arme_id?',
             name: 'grabar.obra',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.obra" */ '@/views/proceso/menu3obra/menu3-1list/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Obra'
                 }
               ]
             }
           },
           {
             path: 'reportes/obra/crear',
             name: 'grabar.obra.create',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.obra.create" */ '@/views/proceso/menu3obra/menu3-2create/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Obra',
                   to: { name: 'grabar.obra' },
                   active: true
                 },
                 {
                   text: 'Crear'
                 }
               ]
             }
           },
           {
             path: 'reportes/obra/editar/:arme_tipo?/:arme_id?/:id?',
             name: 'grabar.obra.edit',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.obra.edit" */ '@/views/proceso/menu3obra/menu3-3edit/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Obra',
                   to: { name: 'grabar.obra' },
                   active: true
                 },
                 {
                   text: 'Editar'
                 }
               ]
             }
           },
           {
             path: 'reportes/cierre/:arme_tipo?/:arme_id?',
             name: 'grabar.cierre',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.cierre" */ '@/views/proceso/menu9cierre/menu9-1directo/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Cierre'
                 }
               ]
             }
           },
           {
             path: 'reportes/ordendetrabajo/:arme_tipo?/:arme_id?',
             name: 'grabar.ordendetrabajo.index',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.ordendetrabajo.index" */ '@/views/new-menu/grabar/orden-trabajo/Index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Orden de Trabajo'
                 }
               ]
             }
           },
           {
             path:
               'reportes/ordendetrabajo/cobranza/cobro/:arme_tipo?/:arme_id?',
             name: 'grabar.ordendetrabajo.cobro',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.ordendetrabajo.cobro" */ '@/views/proceso/menu4orden/menu4-3cobro/menu4-3-1list/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Orden de Trabajo',
                   to: {
                     name: 'grabar.ordendetrabajo.index',
                     params: { arme_tipo: arme_tipo3, arme_id: arme_id3 }
                   }
                 },
                 {
                   text: 'Cobro'
                 }
               ]
             }
           },
           {
             path:
               'reportes/ordendetrabajo/cobranza/factura/:arme_tipo?/:arme_id?',
             name: 'grabar.ordendetrabajo.factura',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.ordendetrabajo.factura" */ '@/views/proceso/menu4orden/menu4-3cobro/menu4-3-2factura/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Orden de Trabajo',
                   to: {
                     name: 'grabar.ordendetrabajo.index',
                     params: { arme_tipo: arme_tipo3, arme_id: arme_id3 }
                   }
                 },
                 {
                   text: 'Factura'
                 }
               ]
             }
           },
           {
             path:
               'reportes/ordendetrabajo/cobranza/actaredimensionamiento/:arme_tipo?/:arme_id?',
             name: 'grabar.ordendetrabajo.acta',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.ordendetrabajo.acta" */ '@/views/proceso/menu4orden/menu4-3cobro/menu4-3-3acta/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Orden de Trabajo',
                   to: {
                     name: 'grabar.ordendetrabajo.index',
                     params: { arme_tipo: arme_tipo3, arme_id: arme_id3 }
                   }
                 },
                 {
                   text: 'Acta'
                 }
               ]
             }
           },
           {
             path: 'reportes/ordendetrabajo/interna/:arme_tipo?/:arme_id?',
             name: 'grabar.ordendetrabajo.interna',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.ordendetrabajo.interna" */ '@/views/proceso/menu4orden/menu4-1interna/menu4-1-1list/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Orden de Trabajo',
                   to: {
                     name: 'grabar.ordendetrabajo.index',
                     params: { arme_tipo: arme_tipo3, arme_id: arme_id3 }
                   }
                 },
                 {
                   text: 'Interna'
                 }
               ]
             }
           },
           {
             path: 'reportes/ordendetrabajo/interna/crear',
             name: 'grabar.ordendetrabajo.interna.create',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.ordendetrabajo.interna.create" */ '@/views/proceso/menu4orden/menu4-1interna/menu4-1-2create/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Orden de Trabajo',
                   to: {
                     name: 'grabar.ordendetrabajo.index',
                     params: { arme_tipo: arme_tipo3, arme_id: arme_id3 }
                   }
                 },
                 {
                   text: 'Interna',
                   to: { name: 'grabar.ordendetrabajo.interna' },
                   active: true
                 },
                 {
                   text: 'Crear'
                 }
               ]
             }
           },
           {
             path: 'reportes/ordendetrabajo/interna/editar/:id',
             name: 'grabar.ordendetrabajo.interna.edit',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.ordendetrabajo.interna.edit" */ '@/views/proceso/menu4orden/menu4-1interna/menu4-1-3edit/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Orden de Trabajo',
                   to: {
                     name: 'grabar.ordendetrabajo.index',
                     params: { arme_tipo: arme_tipo3, arme_id: arme_id3 }
                   }
                 },
                 {
                   text: 'Interna',
                   to: { name: 'grabar.ordendetrabajo.interna' },
                   active: true
                 },
                 {
                   text: 'Editar'
                 }
               ]
             }
           },
           {
             path: 'reportes/ordendetrabajo/historica/:arme_tipo?/:arme_id?',
             name: 'grabar.ordendetrabajo.historica',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.ordendetrabajo.historica" */ '@/views/proceso/menu10historico/menu10-1list/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Orden de Trabajo',
                   to: {
                     name: 'grabar.ordendetrabajo.index',
                     params: { arme_tipo: arme_tipo3, arme_id: arme_id3 }
                   }
                 },
                 {
                   text: 'Historica'
                 }
               ]
             }
           },
           //{
           //  path: 'reportes/ordendetrabajo/historica/crear',
           //  name: 'grabar.ordendetrabajo.historica.create',
           //  component: () =>
           //    import(
           //      /* webpackChunkName: "grabar.ordendetrabajo.historica.create" */ '@/views/proceso/menu4orden/menu4-2externa/menu4-2-2create/index.vue'
           //    ),
           //  meta: {
           //    breadcrumb: [
           //      {
           //        text: 'Dashboard',
           //        to: { name: 'dashboard' },
           //        active: true
           //      },
           //      {
           //        text: 'Grabar',
           //        to: {
           //          name: 'grabar.index',
           //          params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
           //        },
           //        active: true
           //      },
           //      {
           //        text: 'Orden de Trabajo',
           //        to: {
           //          name: 'grabar.ordendetrabajo.index',
           //          params: { arme_tipo: arme_tipo3, arme_id: arme_id3 }
           //        }
           //      },
           //      {
           //        text: 'Historica',
           //        to: { name: 'grabar.ordendetrabajo.historica' },
           //        active: true
           //      },
           //      {
           //        text: 'Crear'
           //      }
           //    ]
           //  }
           //},
           {
             path: 'reportes/ordendetrabajo/historica/editar/:id?',
             name: 'grabar.ordendetrabajo.historica.edit',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.ordendetrabajo.historica.edit" */ '@/views/proceso/menu10historico/menu10-2edit/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Orden de Trabajo',
                   to: {
                     name: 'grabar.ordendetrabajo.index',
                     params: { arme_tipo: arme_tipo3, arme_id: arme_id3 }
                   }
                 },
                 {
                   text: 'Historica',
                   to: { name: 'grabar.ordendetrabajo.historica' },
                   active: true
                 },
                 {
                   text: 'Editar'
                 }
               ]
             }
           },
           {
             path: 'reportes/ordendetrabajo/historica/info/:id',
             name: 'grabar.ordendetrabajo.historica.info',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.ordendetrabajo.historica.info" */ '@/views/proceso/menu4orden/menu4-2externa/menu4-2-4info/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Orden de Trabajo',
                   to: {
                     name: 'grabar.ordendetrabajo.index',
                     params: { arme_tipo: arme_tipo3, arme_id: arme_id3 }
                   }
                 },
                 {
                   text: 'Historica',
                   to: { name: 'grabar.ordendetrabajo.historica' },
                   active: true
                 },
                 {
                   text: 'Info'
                 }
               ]
             }
           },
           {
             path: 'pqrs/radicar/:arme_tipo?/:arme_id?',
             name: 'grabar.radicar',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.radicar" */ '@/views/solicitud/menu1carta/menu1-1list/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Radicar'
                 }
               ]
             }
           },
           {
             path: 'pqrs/radicar/crear',
             name: 'grabar.radicar.create',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.radicar.create" */ '@/views/solicitud/menu1carta/menu1-2create/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Radicar',
                   to: { name: 'grabar.radicar' },
                   active: true
                 },
                 {
                   text: 'Crear'
                 }
               ]
             }
           },
           {
             path: 'pqrs/radicar/editar/:id?',
             name: 'grabar.radicar.edit',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.radicar.edit" */ '@/views/solicitud/menu1carta/menu1-4edit/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Radicar',
                   to: { name: 'grabar.radicar' },
                   active: true
                 },
                 {
                   text: 'Editar'
                 }
               ]
             }
           },
           {
             path: 'pqrs/radicar/ver/:id?',
             name: 'grabar.radicar.view',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.radicar.view" */ '@/views/solicitud/menu1carta/menu1-3view/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Radicar',
                   to: { name: 'grabar.radicar' },
                   active: true
                 },
                 {
                   text: 'Ver'
                 }
               ]
             }
           },
           {
             path: 'asignacioncuadrillas/:arme_tipo?/:arme_id?',
             name: 'grabar.asignacioncuadrillas',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.asignacioncuadrillas" */ '@/views/proceso/menu8cuadrilla/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Asignación de Cuadrillas'
                 }
               ]
             }
           },
           {
             path: '/grabar/actas/liquidacionaom/:arme_tipo?/:arme_id?',
             name: 'grabar.actas.liquidacionaom',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.actas.liquidacionaom" */ '@/views/actas/acta-aom/Form.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Acta AOM'
                 }
               ]
             }
           },
           {
             path: '/grabar/actas/valorinfra/:arme_tipo?/:arme_id?',
             name: 'grabar.actas.valorinfra',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.actas.valorinfra" */ '@/views/actas/acta-valorizacion-infraestructura/Form.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Acta Valorizacion Infraestructura'
                 }
               ]
             }
           },
           {
             path: '/grabar/material/ipp/ipc/:arme_tipo?/:arme_id?',
             name: 'grabar.material.ipp.ipc',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.material.ipp.ipc" */ '@/views/administracion/elemento/menu04/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'IPP/IPC'
                 }
               ]
             }
           },
           {
             path: '/grabar/material/lista/:arme_tipo?/:arme_id?',
             name: 'grabar.material.lista',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.material.lista" */ '@/views/administracion/elemento/menu00/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Lista'
                 }
               ]
             }
           },
           {
             path: '/grabar/material/crear',
             name: 'grabar.material.create',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.material.create" */ '@/views/administracion/elemento/menu01/index'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Materiales',
                   to: { name: 'grabar.material.lista' }
                 },
                 {
                   text: 'Crear'
                 }
               ]
             }
           },
           {
             path: '/grabar/material/editar/:id',
             name: 'grabar.material.edit',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.material.editar" */ '@/views/administracion/elemento/menu02/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Materiales',
                   to: { name: 'grabar.material.lista' }
                 },
                 {
                   text: 'Editar'
                 }
               ]
             }
           },
           {
             path: '/grabar/material/precio/:arme_tipo?/:arme_id?',
             name: 'grabar.material.precio',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.material.precio" */ '@/views/administracion/elemento/menu03/index'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Materiales',
                   to: { name: 'grabar.material.lista' }
                 },
                 {
                   text: 'Precio'
                 }
               ]
             }
           },
           {
             path: '/grabar/barrios/:arme_tipo?/:arme_id?',
             name: 'grabar.barrios',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.barrios" */ '@/views/administracion/barrio'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Barrios'
                 }
               ]
             }
           },
           {
             path: '/grabar/barrios/crear/:did?/:mid?',
             name: 'grabar.barrios.create',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.barrios.create" */ '@/views/administracion/barrio/create'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Barrios',
                   to: { name: 'grabar.barrios' }
                 },
                 {
                   text: 'Crear'
                 }
               ]
             }
           },
           {
             path: '/grabar/barrios/editar/:id',
             name: 'grabar.barrios.edit',
             component: () =>
               import(
                 /* webpackChunkName: "grabar.barrios.edit" */ '@/views/administracion/barrio/edit'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Barrios',
                   to: { name: 'grabar.barrios' }
                 },
                 {
                   text: 'Editar'
                 }
               ]
             }
           },
           {
             path: 'actas/flujoejecutado/:arme_tipo?/:arme_id?',
             name: 'acta.actaflujocajaejecutado',
             component: () =>
               import(
                 /* webpackChunkName: "acta.actaflujocajaejecutado" */ '@/views/new-menu/grabar/flujo-caja/Index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Flujo de Caja Ejecutado'
                 }
               ]
             }
           },
           {
             path: 'admin/cuadrillas/:arme_tipo?/:arme_id?',
             name: 'admin.cuadrillas.index',
             component: () =>
               import(
                 /* webpackChunkName: "admin.cuadrillas" */ '@/views/administracion/cuadrilla.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Cuadrillas'
                 }
               ]
             }
           },
           {
             path: 'admin/cuadrillas/crear',
             name: 'admin.cuadrillas.create',
             component: () =>
               import(
                 /* webpackChunkName: "admin.cuadrillas.create" */ '@/views/administracion/cuadrilla/create.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Cuadrillas',
                   to: { name: 'admin.cuadrillas.index' }
                 },
                 {
                   text: 'Crear'
                 }
               ]
             }
           },
           {
             path: 'admin/cuadrillas/editar/:id',
             name: 'admin.cuadrillas.edit',
             component: () =>
               import(
                 /* webpackChunkName: "admin.cuadrillas.edit" */ '@/views/administracion/cuadrilla/edit.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Cuadrillas',
                   to: { name: 'admin.cuadrillas.index' }
                 },
                 {
                   text: 'Editar'
                 }
               ]
             }
           },
           {
             path: 'admin/abrirreporte/:arme_tipo?/:arme_id?',
             name: 'admin.abrirreporte',
             component: () =>
               import(
                 /* webpackChunkName: "admin.abrirreporte" */ '@/views/autorizacion/abrirreporte/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Abrir Reporte'
                 }
               ]
             }
           },
           {
             path: 'admin/cargareporte/:arme_tipo?/:arme_id?',
             name: 'admin.cargarreporte',
             component: () =>
               import(
                 /* webpackChunkName: "admin.cargarreporte" */ '@/views/autorizacion/cargarreporte/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Cargar Reporte'
                 }
               ]
             }
           },
           {
             path: 'admin/crearaap/:arme_tipo?/:arme_id?',
             name: 'admin.crearaap',
             component: () =>
               import(
                 /* webpackChunkName: "admin.crearaap" */ '@/views/autorizacion/crearaap/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Crear AAP'
                 }
               ]
             }
           },
           {
             path: 'admin/recuperaraap/:arme_tipo?/:arme_id?',
             name: 'admin.recuperaraap',
             component: () =>
               import(
                 /* webpackChunkName: "admin.recuperaraap" */ '@/views/autorizacion/recuperaraap/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Recuperar AAP'
                 }
               ]
             }
           },
           {
             path: 'admin/mano/obralista/:arme_tipo?/:arme_id?',
             name: 'admin.mano.obralista',
             component: () =>
               import(
                 /* webpackChunkName: "admin.mano.obralista" */ '@/views/administracion/manoobraorden/menu01/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Mano de Obra'
                 }
               ]
             }
           },
           {
             path: 'admin/mano/obraprecio/:arme_tipo?/:arme_id?',
             name: 'admin.mano.obraprecio',
             component: () =>
               import(
                 /* webpackChunkName: "admin.mano.obraprecio" */ '@/views/administracion/manoobraorden/menu02/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Mano de Obra'
                 }
               ]
             }
           },
           {
             path: 'admin/unitario/:arme_tipo?/:arme_id?',
             name: 'admin.unitario.index',
             component: () =>
               import(
                 /* webpackChunkName: "admin.unitario.index" */ '@/views/administracion/unitario.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Unitario'
                 }
               ]
             }
           },
           {
             path: 'admin/unitario/crear',
             name: 'admin.unitario.create',
             component: () =>
               import(
                 /* webpackChunkName: "admin.unitario.create" */ '@/views/administracion/unitario/create.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Unitario',
                   to: { name: 'admin.unitario.index' }
                 },
                 {
                   text: 'Crear'
                 }
               ]
             }
           },
           {
             path: 'admin/unitario/editar/:id',
             name: 'admin.unitario.edit',
             component: () =>
               import(
                 /* webpackChunkName: "admin.unitario.edit" */ '@/views/administracion/unitario/edit.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Unitario',
                   to: { name: 'admin.unitario.index' }
                 },
                 {
                   text: 'Editar'
                 }
               ]
             }
           },
           {
             path: 'admin/unidad/:arme_tipo?/:arme_id?',
             name: 'admin.unidad.index',
             component: () =>
               import(
                 /* webpackChunkName: "admin.unidad.index" */ '@/views/administracion/unidad.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Unidad'
                 }
               ]
             }
           },
           {
             path: 'admin/unidad/crear',
             name: 'admin.unidad.create',
             component: () =>
               import(
                 /* webpackChunkName: "admin.unidad.create" */ '@/views/administracion/unidad/create.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Unidad',
                   to: { name: 'admin.unidad.index' }
                 },
                 {
                   text: 'Crear'
                 }
               ]
             }
           },
           {
             path: 'admin/unidad/editar/:id',
             name: 'admin.unidad.edit',
             component: () =>
               import(
                 /* webpackChunkName: "admin.unidad.edit" */ '@/views/administracion/unidad/edit.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Unidad',
                   to: { name: 'admin.unidad.index' }
                 },
                 {
                   text: 'Editar'
                 }
               ]
             }
           },
           {
             path: 'admin/tipomaterial/:arme_tipo?/:arme_id?',
             name: 'admin.tipomaterial.index',
             component: () =>
               import(
                 /* webpackChunkName: "admin.tipoelemento.index" */ '@/views/administracion/tipoelemento.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Tipo Material'
                 }
               ]
             }
           },
           {
             path: 'admin/tipomaterial/crear',
             name: 'admin.tipomaterial.create',
             component: () =>
               import(
                 /* webpackChunkName: "admin.tipomaterial.create" */ '@/views/administracion/tipoelemento/create'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Tipo Material',
                   to: { name: 'admin.tipomaterial.index' }
                 },
                 {
                   text: 'Crear'
                 }
               ]
             }
           },
           {
             path: 'admin/tipomaterial/editar/:id',
             name: 'admin.tipomaterial.edit',
             component: () =>
               import(
                 /* webpackChunkName: "admin.tipomaterial.edit" */ '@/views/administracion/tipoelemento/edit'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Tipo Material',
                   to: { name: 'admin.tipomaterial.index' }
                 },
                 {
                   text: 'Editar'
                 }
               ]
             }
           },
           {
             path: 'admin/herramientalista/:arme_tipo?/:arme_id?',
             name: 'admin.herramientalista.index',
             component: () =>
               import(
                 /* webpackChunkName: "admin.herramientalista.index" */ '@/views/administracion/manoherramientaorden/menu01/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Transporte Herramienta Lista'
                 }
               ]
             }
           },
           {
             path: 'admin/herramientaprecio/:arme_tipo?/:arme_id?',
             name: 'admin.herramientaprecio.index',
             component: () =>
               import(
                 /* webpackChunkName: "admin.herramientaprecio.index" */ '@/views/administracion/manoherramientaorden/menu02/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Transporte Herramienta Precio'
                 }
               ]
             }
           },
           {
             path: 'admin/contratista/:arme_tipo?/:arme_id?',
             name: 'admin.contratista.index',
             component: () =>
               import(
                 /* webpackChunkName: "admin.contratista.index" */ '@/views/administracion/contratista/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Contratista'
                 }
               ]
             }
           },
           {
             path: 'admin/contratista/crear',
             name: 'admin.contratista.crear',
             component: () =>
               import(
                 /* webpackChunkName: "admin.contratista.index" */ '@/views/administracion/contratista/create.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Contratista',
                   to: { name: 'admin.contratista.index' },
                   active: true
                 },
                 {
                   text: 'Grabar Contratista'
                 }
               ]
             }
           },
           {
             path: 'admin/contratista/editar/:id?',
             name: 'admin.contratista.editar',
             component: () =>
               import(
                 /* webpackChunkName: "admin.contratista.editar" */ '@/views/administracion/contratista/edit.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Contratista',
                   to: { name: 'admin.contratista.index' },
                   active: true
                 },
                 {
                   text: 'Editar Contratista'
                 }
               ]
             }
           },
           {
             path: 'admin/medidorucaps/:arme_tipo?/:arme_id?',
             name: 'admin.medidorucaps.index',
             component: () =>
               import(
                 /* webpackChunkName: "admin.medidorucaps.index" */ '@/views/administracion/medidor.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Medidor Ucaps'
                 }
               ]
             }
           },
           {
             path: 'admin/medidorucaps/crear',
             name: 'admin.medidorucaps.crear',
             component: () =>
               import(
                 /* webpackChunkName: "admin.medidorucaps.crear" */ '@/views/administracion/medidor/create.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Medidor Ucaps',
                   to: { name: 'admin.medidorucaps.index' },
                   active: true
                 },
                 {
                   text: 'Crear Medidor Ucaps'
                 }
               ]
             }
           },
           {
             path: 'admin/medidorucaps/editar/:id?',
             name: 'admin.medidorucaps.editar',
             component: () =>
               import(
                 /* webpackChunkName: "admin.medidorucaps.editar" */ '@/views/administracion/medidor/edit.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Medidor Ucaps',
                   to: { name: 'admin.medidorucaps.index' },
                   active: true
                 },
                 {
                   text: 'Editar Medidor Ucaps'
                 }
               ]
             }
           },
           {
             path: 'admin/urbanizadora/:arme_tipo?/:arme_id?',
             name: 'admin.urbanizadora.index',
             component: () =>
               import(
                 /* webpackChunkName: "admin.urbanizadora.index" */ '@/views/administracion/urbanizadora.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Urbanizadora'
                 }
               ]
             }
           },
           {
             path: 'admin/urbanizadora/crear',
             name: 'admin.urbanizadora.crear',
             component: () =>
               import(
                 /* webpackChunkName: "admin.urbanizadora.crear" */ '@/views/administracion/urbanizadora/create.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Ubanizador',
                   to: { name: 'admin.urbanizadora.index' },
                   active: true
                 },
                 {
                   text: 'Crear Ubanizador'
                 }
               ]
             }
           },
           {
             path: 'admin/urbanizadora/editar/:urba_id?',
             name: 'admin.urbanizadora.editar',
             component: () =>
               import(
                 /* webpackChunkName: "admin.urbanizadora.editar" */ '@/views/administracion/urbanizadora/edit.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Ubanizador',
                   to: { name: 'admin.urbanizadora.index' },
                   active: true
                 },
                 {
                   text: 'Editar Ubanizador'
                 }
               ]
             }
           },
           {
             path: 'admin/obralista/:arme_tipo?/:arme_id?',
             name: 'admin.obralista.index',
             component: () =>
               import(
                 /* webpackChunkName: "admin.obralista.index" */ '@/views/acta-obra/menu1list/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Obra Lista'
                 }
               ]
             }
           },
           {
             path: 'admin/obralista/crear',
             name: 'admin.obralista.crear',
             component: () =>
               import(
                 /* webpackChunkName: "admin.obralista.crear" */ '@/views/acta-obra/menu2create/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Obra Lista',
                   to: { name: 'admin.obralista.index' },
                   active: true
                 },
                 {
                   text: 'Crear Obra Lista'
                 }
               ]
             }
           },
           {
             path: 'admin/obraitem/:arme_tipo?/:arme_id?',
             name: 'admin.obraitem.index',
             component: () =>
               import(
                 /* webpackChunkName: "admin.obraitem.index" */ '@/views/acta-obra/menu4item/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Obra Item'
                 }
               ]
             }
           },
           {
             path: 'admin/empresa/:arme_tipo?/:arme_id?',
             name: 'admin.empresa.index',
             component: () =>
               import(
                 /* webpackChunkName: "admin.empresa.index" */ '@/views/administracion/empresa.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Empresa'
                 }
               ]
             }
           },
           {
             path: 'admin/empresa/crear',
             name: 'admin.empresa.crear',
             component: () =>
               import(
                 /* webpackChunkName: "admin.empresa.crear" */ '@/views/administracion/empresa/create.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Empresa',
                   to: { name: 'admin.empresa.index' },
                   active: true
                 },
                 {
                   text: 'Crear Empresa'
                 }
               ]
             }
           },
           {
             path: 'admin/empresa/editar/:empr_id?',
             name: 'admin.empresa.editar',
             component: () =>
               import(
                 /* webpackChunkName: "admin.empresa.editar" */ '@/views/administracion/empresa/edit.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Empresa',
                   to: { name: 'admin.empresa.index' },
                   active: true
                 },
                 {
                   text: 'Editar Empresa'
                 }
               ]
             }
           },
           {
             path: 'reportes/migracion/:arme_tipo?/:arme_id?',
             name: 'reportes.migracion.index',
             component: () =>
               import(
                 /* webpackChunkName: "reportes.migracion.index" */ '@/views/proceso/menu1reporte/menu1-99migracion/menu1-99-1list/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Reportes',
                   to: { name: 'reportes.index' }
                 },
                 {
                   text: 'Migracion'
                 }
               ]
             }
           },
           {
             path: 'admin/caracteristicasucaps/:arme_tipo?/:arme_id?',
             name: 'admin.caracteristicasucaps.index',
             component: () =>
               import(
                 /* webpackChunkName: "admin.caracteristicasucaps.index" */ '@/views/new-menu/grabar/caracteristicas-ucaps/Index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Caracteristicas Ucaps'
                 }
               ]
             }
           },
           {
             path: 'admin/masiva/ucap/:arme_tipo?/:arme_id?',
             name: 'admin.masiva.ucap.index',
             component: () =>
               import(
                 /* webpackChunkName: "admin.masiva.ucap.index" */ '@/views/new-menu/grabar/administrativo/CargaMasivoUcap.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Masivo Ucap'
                 }
               ]
             }
           }
         ]
       }
